import React, {useState} from 'react';
import Select from 'react-select';
import {useIntl} from 'react-intl';
import classnames from 'classnames';
import {filterOptions} from '../../../../../utils/filterOptions';
import ClearIcon from '../ClearIcon';
import {commonStyles, filtersBar} from '../../selectStyles/customSelectStyles';
import styles from './styles.module.scss';

const FilterSelect = ({
                        fieldName,
                        options = [],
                        placeholder,
                        valueName,
                        containerClassnames = '',
                        labelClassNames = '',
                        disabled,
                        setFieldValue,
                        handleSubmit,
                        onChange,
                        onClear,
                        showLabel = true,
                      }) => {
  const intl = useIntl();
  const [selectValue, setSelectValue] = useState({key: null});

  return (
    <div className={classnames(styles.container, containerClassnames)}>
      {Boolean(valueName) && showLabel && <div className={classnames(styles.label, labelClassNames)}>{placeholder}</div>}
      <Select
        name={fieldName}
        value={filterOptions(valueName)(options)}
        onChange={({value}) => {
          if (onChange) {
            onChange({value});
          } else {
            setSelectValue({...selectValue, key: value});
            setFieldValue(`${fieldName}`, `${value}`);
            handleSubmit();
          }
        }}
        options={options}
        styles={{...commonStyles, ...filtersBar}}
        placeholder={placeholder}
        noOptionsMessage={() => intl.formatMessage({id: 'label-no-options', defaultMessage: 'No options'})}
        isDisabled={disabled}
      />
      <ClearIcon
        onClick={() => {
          if (!disabled) {
            if (onClear) {
              onClear();
            } else {
              setFieldValue(`${fieldName}`, '');
              handleSubmit();
              setSelectValue({key: null});
            }
          }
        }}
      />
    </div>
  );
};

export default FilterSelect;
